import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import GrupoContactoTable from './GrupoContactoTable';
import WindowHeader from '../../../commons/WindowHeader';

const GrupoContacto = (props: any) => {
    const { contactos, grupoId } = props;
    const dispatch = useDispatch();


    console.log('App loading');



    return (
        <>
            <WindowHeader title="Contactos"></WindowHeader>
            <GrupoContactoTable contactos={contactos}></GrupoContactoTable>
        </>

    );
}

export default GrupoContacto;
